export const notifications = [
  {
    image: require("assets/images/avatar/stella-johnson.png"),
    title: "Stella Johnson has recently posted an album",
    time: "4:10 PM",
    icon: "thumb-up gx-text-blue",
  },
  {
    image: require("assets/images/avatar/a5.png"),
    title: "Alex Brown has shared Martin Guptil's post",
    time: "5:18 PM",
    icon: "chat gx-text-grey",
  },
  {
    image: require("assets/images/avatar/domnic-brown.png"),
    title: "Domnic Brown has sent you a group invitation for Global Health",
    time: "5:36 PM",
    icon: "birthday text-info",
  },
  {
    image: require("assets/images/avatar/john-smith.png"),
    title: "John Smith has birthday today",
    time: "5:54 PM",
    icon: "birthday gx-text-warning",
  },
  {
    image: require("assets/images/avatar/a6.png"),
    title: "Chris has updated his profile picture",
    time: "5:25 PM",
    icon: "profile gx-text-grey",
  },
];
